<div class="section-label">
  <div class="review_edit-area">
    <div *ngIf="reviewState === reviewStates.ReadOnly">
      <app-icon-button
        icon="edit"
        label="EDIT"
        (click)="editDetails()"
      ></app-icon-button>
    </div>
    <div *ngIf="reviewState === reviewStates.Edit">
      <a
        role="button"
        tabindex="0"
        mat-button
        class="buttonLink"
        (keyup.space)="save()"
        (keyup.enter)="save()"
        [class.spinner]="loading"
        [disabled]="loading"
        href="javascript: void(0)"
        (click)="save()"
        >Save</a
      >
      <a
        role="button"
        tabindex="0"
        mat-button
        class="buttonLink"
        [disabled]="loading"
        (keyup.space)="cancel()"
        (keyup.enter)="cancel()"
        (click)="cancel()"
        href="javascript: void(0)"
        >Cancel</a
      >
    </div>
  </div>
</div>
<form [formGroup]="formGroup">
  <h3 class="section-sub-label">Personal Details</h3>
  <div
    *ngIf="reviewState != reviewStates.ReadOnly"
    fxLayout="row"
    fxLayout.xs="column"
    class="subtitle-margin"
  >
    <div fxFlex="100">
      <div class="personalDetailMessage">{{ personalDetailMessage }}</div>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="end center">
    <span
      class="required-indicator"
      *ngIf="reviewState != reviewStates.ReadOnly"
      >* Required Fields</span
    >
  </div>
  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutAlign="space-between stretch"
    fxLayoutGap="10px"
  >
    <div
      fxFlex="27"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="
          reviewState != reviewStates.ReadOnly && !isInAuthenticatedFlow
        "
        id="firstName-label"
        >{{ !isInReadOnlyState ? "*" : ""
        }}<label for="firstName">First Name</label>
      </mat-label-tooltip>
      <ng-container
        *ngIf="reviewState != reviewStates.ReadOnly && !isInAuthenticatedFlow"
        class="form-input"
      >
        <mat-form-field appearance="outline">
          <input
            id="firstName"
            maxlength="40"
            formControlName="firstName"
            autocomplete="given-name"
            data-dd-privacy="mask-user-input"
            matInput
            required
          />
          <mat-error>{{ this.getFieldError("firstName") }}</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-container
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly || isInAuthenticatedFlow"
      >
        <mat-label
          class="read-only-label"
          for="firstName"
          data-dd-privacy="mask"
          >{{ getFormControlValue("firstName") }}</mat-label
        >
      </ng-container>
    </div>
    <div
      fxFlex="27"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="
          reviewState != reviewStates.ReadOnly && !isInAuthenticatedFlow
        "
        id="middleName-label"
        ><label for="middleName">Middle Name</label>
      </mat-label-tooltip>
      <ng-container
        *ngIf="reviewState != reviewStates.ReadOnly && !isInAuthenticatedFlow"
        class="form-input"
      >
        <mat-form-field appearance="outline">
          <input
            matInput
            id="middleName"
            maxlength="40"
            formControlName="middleName"
            autocomplete="additional-name"
            data-dd-privacy="mask-user-input"
          />
          <mat-error>{{ this.getFieldError("middleName") }}</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-container
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly || isInAuthenticatedFlow"
      >
        <mat-label
          class="read-only-label"
          data-dd-privacy="mask"
          for="middleName"
          >{{ getFormControlValue("middleName") }}&nbsp;</mat-label
        >
      </ng-container>
    </div>
    <div
      fxFlex="27"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="
          reviewState != reviewStates.ReadOnly && !isInAuthenticatedFlow
        "
        id="lastName-label"
        role="label"
        for="lastName"
        >{{ !isInReadOnlyState ? "*" : ""
        }}<label for="lastName">Last Name</label>
      </mat-label-tooltip>
      <ng-container
        *ngIf="reviewState != reviewStates.ReadOnly && !isInAuthenticatedFlow"
        class="form-input"
      >
        <mat-form-field appearance="outline">
          <input
            matInput
            id="lastName"
            formControlName="lastName"
            maxlength="40"
            autocomplete="family-name"
            data-dd-privacy="mask-user-input"
            required
          />
          <mat-error>{{ this.getFieldError("lastName") }}</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-container
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly || isInAuthenticatedFlow"
      >
        <mat-label
          class="read-only-label"
          for="lastName"
          data-dd-privacy="mask"
          >{{ getFormControlValue("lastName") }}</mat-label
        >
      </ng-container>
    </div>
    <div
      fxFlex="12"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="reviewState != reviewStates.ReadOnly"
        id="suffix-label"
        ><label for="suffix">Suffix</label>
      </mat-label-tooltip>
      <div *ngIf="reviewState != reviewStates.ReadOnly" class="form-input">
        <mat-form-field appearance="outline">
          <mat-select
            placeholder="-Select-"
            formControlName="suffix"
            autocomplete="family-name"
            id="suffix"
            aria-label="suffix"
          >
            <mat-option value=""></mat-option>
            <mat-option value="Sr">Sr</mat-option>
            <mat-option value="Jr">Jr</mat-option>
            <mat-option value="II">II</mat-option>
            <mat-option value="III">III</mat-option>
            <mat-option value="IV">IV</mat-option>
            <mat-option value="V">V</mat-option>
            <mat-option value="MD">MD</mat-option>
            <mat-option value="Esq">Esq</mat-option>
          </mat-select>
          <mat-error class="accessibilityError">{{
            this.getFieldError("suffix")
          }}</mat-error>
        </mat-form-field>
      </div>
      <div
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly"
      >
        <mat-label class="read-only-label" for="suffix"
          >{{ getFormControlValue("suffix") }}&nbsp;</mat-label
        >
      </div>
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayout.xs="column"
    *ngIf="isPWAProduct"
    fxLayoutAlign="start start"
    fxLayoutGap="5px"
  >
    <div fxFlex="25" fxLayout="column">
      <mat-label-tooltip
        [showToolTip]="reviewState != reviewStates.ReadOnly"
        id="preferredName-label"
        ><label for="preferredName">Preferred Name</label>
      </mat-label-tooltip>
      <div *ngIf="reviewState != reviewStates.ReadOnly" class="form-input">
        <mat-form-field appearance="outline">
          <input
            id="preferredName"
            formControlName="preferredName"
            autocomplete="preferred-name"
            matInput
          />
          <mat-error class="accessibilityError">{{
            this.getFieldError("preferredName")
          }}</mat-error>
        </mat-form-field>
      </div>
      <div
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly"
      >
        <mat-label class="read-only-label" for="preferredName">{{
          getFormControlValue("preferredName")
        }}</mat-label>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxLayout.xs="column" *ngIf="!isPrimary">
    <mat-divider></mat-divider>
    <div fxFlex="50" fxLayout="column">
      <div>Use same address as primary applicant?</div>
    </div>
    <div fxFlex="50" class="labelDiv" fxLayout="column">
      <div fxFlex *ngIf="reviewState !== reviewStates.ReadOnly">
        <mat-radio-group (change)="onUsePrimaryAddress($event)">
          <mat-radio-button
            [value]="true"
            id="yes"
            [checked]="usePrimaryAddress"
            ><label for="yes">Yes</label></mat-radio-button
          >
          <mat-radio-button
            [value]="false"
            [checked]="!usePrimaryAddress"
            id="no"
            ><label for="no">No</label></mat-radio-button
          >
        </mat-radio-group>
      </div>
      <div fxFlex *ngIf="reviewState === reviewStates.ReadOnly">
        <div *ngIf="usePrimaryAddress">Yes</div>
        <div *ngIf="!usePrimaryAddress">No</div>
      </div>
    </div>
    <br />
    <br />
  </div>

  <ng-container *ngIf="isPrimary || !usePrimaryAddress">
    <div
      fxLayout="row"
      fxLayout.xs="column"
      fxLayoutAlign="space-between stretch"
      fxLayoutGap="10px"
    >
      <div
        fxFlex="50"
        class="address1Div labelDiv"
        fxLayout="column"
        fxLayoutAlign="end start"
        fxLayoutGap="5px"
      >
        <mat-label-tooltip id="addressLine1-label"
          >{{ !isInReadOnlyState ? "*" : ""
          }}<label for="addressLine1">Address Line 1</label></mat-label-tooltip
        >
        <div *ngIf="reviewState != reviewStates.ReadOnly" class="form-input">
          <mat-form-field appearance="outline">
            <input
              matInput
              ngx-google-places-autocomplete
              (onAddressChange)="fillInAddress($event)"
              [options]="options"
              formControlName="addressLine1"
              id="addressLine1"
              autocomplete="off"
              aria-autocomplete="list"
              aria-controls="pac-container"
              aria-haspopup="listbox"
              required
              data-dd-privacy="mask-user-input"
              maxlength="51"
            />
            <mat-error>{{ this.getFieldError("addressLine1") }}</mat-error>
            <mat-hint style="display: none"
              >Begin typing an address, arrow down to see results, use arrow
              keys to navigate, Enter to select</mat-hint
            >
          </mat-form-field>
        </div>
        <div
          class="read-only-label"
          *ngIf="reviewState === reviewStates.ReadOnly"
        >
          <mat-label class="read-only-label" for="addressLine1">{{
            getFormControlValue("addressLine1")
          }}</mat-label>
        </div>
      </div>
      <div
        fxFlex="50"
        class="address1Div labelDiv"
        fxLayout="column"
        fxLayoutAlign="end start"
        fxLayoutGap="5px"
      >
        <mat-label-tooltip id="addressLine2-label"
          ><label for="addressLine2">Address Line 2</label></mat-label-tooltip
        >
        <div *ngIf="reviewState != reviewStates.ReadOnly" class="form-input">
          <mat-form-field appearance="outline">
            <input
              matInput
              id="addressLine2"
              maxlength="40"
              formControlName="addressLine2"
              data-dd-privacy="mask-user-input"
              autocomplete="address-line2"
              aria-autocomplete="none"
              name="addressLine2"
            />
          </mat-form-field>
        </div>
        <div
          class="read-only-label"
          *ngIf="reviewState === reviewStates.ReadOnly"
        >
          <mat-label class="read-only-label" for="addressLine2">{{
            getFormControlValue("addressLine2")
          }}</mat-label>
        </div>
      </div>
    </div>
    <div
      fxLayout="column"
      fxLayout.gt-xs="row"
      fxLayoutAlign="space-between stretch"
      fxLayoutGap="10px"
    >
      <div
        fxFlex="30"
        fxLayout="column"
        fxLayoutAlign="end start"
        fxLayoutGap="5px"
      >
        <mat-label-tooltip id="city-label"
          >{{ !isInReadOnlyState ? "*" : ""
          }}<label for="city">City</label></mat-label-tooltip
        >
        <div *ngIf="reviewState != reviewStates.ReadOnly" class="form-input">
          <mat-form-field appearance="outline">
            <input
              matInput
              type="text"
              id="city"
              maxlength="24"
              formControlName="city"
              required
              data-dd-privacy="mask-user-input"
              name="city"
              autocomplete="address-level2"
              aria-autocomplete="none"
              />
            <mat-error>{{ this.getFieldError("city") }}</mat-error>
          </mat-form-field>
        </div>
        <div
          class="read-only-label"
          *ngIf="reviewState === reviewStates.ReadOnly"
        >
          <mat-label class="read-only-label" for="city">{{
            getFormControlValue("city")
          }}</mat-label>
        </div>
      </div>

      <div
        fxFlex="38"
        fxLayout="column"
        fxLayoutAlign="space-between stretch"
        fxLayoutGap="5px"
      >
        <mat-label-tooltip id="state-label"
          >{{ !isInReadOnlyState ? "*" : ""
          }}<label for="state">State</label></mat-label-tooltip
        >
        <div *ngIf="reviewState != reviewStates.ReadOnly" class="form-input">
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              placeholder="-Select-"
              required
              id="state"
              formControlName="state"
              [compareWith]="compareValueWithSelection"
              [aria-label]="
                isPrimary ? 'Primary applicant state' : 'Co-applicant state'
              "
              data-dd-privacy="mask-user-input"
            >
              <mat-option
                *ngFor="let curState of stateList"
                [value]="curState.id"
                [attr.data-stateAbbr]="curState.stateAbbr"
                >{{ curState.stateName }}</mat-option
              >
            </mat-select>
            <mat-error>{{ this.getFieldError("state") }}</mat-error>
            <mat-hint style="display: none">Enter to expand</mat-hint>
          </mat-form-field>
        </div>
        <div
          class="read-only-label"
          *ngIf="reviewState === reviewStates.ReadOnly"
        >
          <mat-label class="read-only-label" for="state">{{
            getStateAbbr(getFormControlValue("state"))
          }}</mat-label>
        </div>
      </div>
      <div
        fxFlex="30"
        fxLayout="column"
        fxLayoutAlign="end start"
        fxLayoutGap="5px"
      >
        <mat-label-tooltip id="zip-label"
          >{{ !isInReadOnlyState ? "*" : ""
          }}<label for="zip">Zip Code</label></mat-label-tooltip
        >
        <div *ngIf="reviewState != reviewStates.ReadOnly" class="form-input">
          <mat-form-field appearance="outline">
            <input
              matInput
              id="zipCode"
              formControlName="zipCode"
              required
              data-dd-privacy="mask-user-input"
              autocomplete="postal-code"
              aria-autocomplete="none"
              name="zipCode"
              aria-label="zipcode"
            />
            <mat-error>{{ this.getFieldError("zipCode") }}</mat-error>
          </mat-form-field>
        </div>
        <div
          class="read-only-label"
          *ngIf="reviewState === reviewStates.ReadOnly"
        >
          <mat-label class="read-only-label" for="zipCode">{{
            getFormControlValue("zipCode")
          }}</mat-label>
        </div>
      </div>
    </div>
  </ng-container>
  <div
    fxLayout="row"
    fxLayout.xs="column"
    fxLayoutAlign="space-between stretch"
    fxLayoutGap="10px"
  >
    <div
      fxFlex="30"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="
          reviewState != reviewStates.ReadOnly && !isInAuthenticatedFlow
        "
        id="birthDate-label"
        >{{ !isInReadOnlyState ? "*" : ""
        }}<label for="birthDate">Date of Birth (MM/DD/YYYY)</label>
      </mat-label-tooltip>
      <ng-container
        *ngIf="reviewState != reviewStates.ReadOnly && !isInAuthenticatedFlow"
        class="form-input"
      >
        <mat-form-field appearance="outline">
          <input
            matInput
            [matDatepicker]="dp"
            id="birthDate"
            formControlName="birthDate"
            (keyup)="onDateKeyUp($event)"
            [min]="minDate"
            [max]="maxDate"
            autocomplete="bday"
            required
            data-dd-privacy="mask-user-input"
          />
          <mat-error>{{ this.getFieldError("birthDate") }}</mat-error>
          <mat-hint style="display: none">date format: MM/DD/YYYY</mat-hint>
          <mat-datepicker #dp></mat-datepicker>
          <mat-datepicker-toggle matSuffix [for]="dp" [aria-label]="dp.opened ? 'Calendar selection in progress' : 'Open calendar'">
          </mat-datepicker-toggle>
        </mat-form-field>
      </ng-container>
      <ng-container
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly || isInAuthenticatedFlow"
      >
        <mat-label
          class="read-only-label"
          data-dd-privacy="mask"
          for="birthDate"
          >{{
            formatBirthDate(getFormControlValue("birthDate"))
          }}</mat-label
        >
      </ng-container>
    </div>
    <div
      fxFlex="38"
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="reviewState != reviewStates.ReadOnly && isReadOnlySsnInvalid()"
        id="ssn-label"
        >{{ !isInReadOnlyState ? "*" : ""
        }}<label for="ssnNumber">Social Security Number</label>
      </mat-label-tooltip>
      <ng-container
        *ngIf="reviewState != reviewStates.ReadOnly && !isReadOnlySsnInvalid()"
        class="form-input"
      >
        <mat-form-field appearance="outline">
          <input
            matInput
            [mask]="ssnMask"
            [hiddenInput]="isSSNHiddenInput"
            id="ssnNumber"
            [type]="hideSsn ? 'password' : 'text'"
            formControlName="ssnNumber"
            autocomplete="off"
            (blur)="ssnFieldMaskOnBlur()"
            required
            data-dd-privacy="mask-user-input"
            [name]="ssnNoAutofill"
          />
          <mat-error>{{ this.getFieldError("ssnNumber") }}</mat-error>
          <mat-error *ngIf="formGroup.get('ssnNumber')?.hasError('duplicated')"
            >Primary and Co-Applicant Social Security Numbers must not
            match.</mat-error
          >
          <button
            mat-icon-button
            matSuffix
            [attr.aria-label]="hideSsn ? 'Hide social security number': 'Show social security number'"
            [attr.aria-pressed]="!hideSsn"
            (keyup.space)="handleSSNkeypress($event)"
            (keydown.enter)="handleSSNkeypress($event)"
            (click)="hideSsn = !hideSsn"
            >
            <mat-icon
            class="click-icon"
            id="ssnVisibility"
              >{{ hideSsn ? "visibility_off" : "visibility" }}</mat-icon
            >
          </button>
        </mat-form-field>
      </ng-container>
      <ng-container
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly"
      >
        <mat-label
          class="read-only-label"
          data-dd-privacy="mask"
          for="ssnNumber"
          >{{ getFormControlValue("ssnNumber") | ssnmask : true }}</mat-label
        >
        <div class="mat-error" *ngIf="isReadOnlySsnInvalid()">
          Please enter a valid SSN.
        </div>
      </ng-container>
    </div>
    <div
      fxFlex="30"
      class="phoneDiv labelDiv"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="reviewState != reviewStates.ReadOnly"
        id="phoneNumber-label"
        >{{ !isInReadOnlyState ? "*" : ""
        }}<label for="phone">Mobile Number</label>
      </mat-label-tooltip>
      <div *ngIf="reviewState != reviewStates.ReadOnly" class="form-input">
        <mat-form-field appearance="outline">
          <input
            matInput
            mask="000-000-0000"
            [showMaskTyped]="true"
            id="phone"
            name="searchPhoneNumber"
            formControlName="phoneNumber"
            type="tel"
            autocomplete="off"
            data-dd-privacy="mask-user-input"
          />
          <mat-error>{{ this.getFieldError("phoneNumber") }}</mat-error>
          <mat-error
            *ngIf="formGroup.get('phoneNumber')?.hasError('duplicated')"
            >Primary and Co-Applicant Mobile Number must not match.</mat-error
          >
        </mat-form-field>
      </div>
      <ng-container
        class="read-only-label"
        *ngIf="reviewState === reviewStates.ReadOnly"
      >
        <mat-label
          class="read-only-label"
          data-dd-privacy="mask"
          for="phoneNumber"
          >{{
            getFormControlValue("phoneNumber") | mask : "000-000-0000"
          }}</mat-label
        >
      </ng-container>
    </div>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="space-between center">
    <div
      fxFlex="100"
      fxLayout="column"
      fxLayoutAlign="end start"
      fxLayoutGap="5px"
    >
      <mat-label-tooltip
        [showToolTip]="reviewState != reviewStates.ReadOnly"
        id="email-label"
        >{{ !isInReadOnlyState ? "*" : ""
        }}<label for="email">Personal Email Address</label></mat-label-tooltip
      >
      <div
        *ngIf="
          reviewState != reviewStates.ReadOnly && !isInJointMaintenanceFlow
        "
        class="form-input"
      >
        <mat-form-field appearance="outline">
          <input
            matInput
            type="email"
            id="email"
            formControlName="emailAddress"
            autocomplete="off"
            data-dd-privacy="mask-user-input"
            [name]="emailNoAutofill"
          />
          <mat-error>{{ this.getFieldError("emailAddress") }}</mat-error>
          <mat-error *ngIf="formGroup.get('email')?.hasError('required')"
            >Email is required</mat-error
          >
          <mat-error *ngIf="formGroup.get('email')?.hasError('duplicated')"
            >Primary and Co-Applicant emails must not match.</mat-error
          >
        </mat-form-field>
      </div>
      <ng-container
        class="read-only-label overflow-control"
        *ngIf="
          reviewState === reviewStates.ReadOnly || isInJointMaintenanceFlow
        "
      >
        <mat-label for="emial" class="read-only-label" data-dd-privacy="mask">{{
          getFormControlValue("emailAddress")
        }}</mat-label>
      </ng-container>
    </div>
  </div>

  <mat-divider *ngIf="!isInAuthenticatedFlow"></mat-divider>

  <div *ngIf="!isInAuthenticatedFlow" class="section" [ngClass]="{'mat-form-field-wrapper': reviewState != reviewStates.ReadOnly,
        'p-b-14': isInAuthenticatedFlow}">
    <div [fxLayout]="(isPWABrand$ | async) ? 'row' : reviewState === reviewStates.ReadOnly ? 'column' : 'row'" 
          fxLayout.xs="column">
      <div [fxFlex]="reviewState === reviewStates.ReadOnly && !isInAuthenticatedFlow ? '100' : '70'">
        <mat-label-tooltip [showToolTip]="reviewState != reviewStates.ReadOnly"
          id="us-citizen">
          {{ !isInReadOnlyState ? "*" : "" }}
          <label for="isUSCitizen">Are you a U.S. citizen?</label>
        </mat-label-tooltip>
      </div>
      <div [fxFlex]="reviewState === reviewStates.ReadOnly && !isInAuthenticatedFlow ? '100' : '30'" class="options">
        <div *ngIf="reviewState != reviewStates.ReadOnly || (isPWABrand$ | async)" [ngClass]="{'justify-content-space-evenly': (isPWABrand$ | async),
      'justify-content-end': !(isPWABrand$ | async) && !isInAuthenticatedFlow}">
          <mat-radio-group aria-label="Are you a U S Citizen?" id="isUSCitizen" formControlName="isUSCitizen">
            <mat-radio-button id="isUSCitizenYes" [value]="true"
              >Yes</mat-radio-button
            >
            <mat-radio-button id="isUSCitizenNo" [value]="false"
              >No</mat-radio-button
            >
          </mat-radio-group>
        </div>
        <div class="read-only-label" *ngIf="reviewState === reviewStates.ReadOnly && !isInAuthenticatedFlow && !(isPWABrand$ | async)">
          <mat-label class="read-only-label">{{
            getFormControlValue("isUSCitizen") === true
              ? "Yes"
              : getFormControlValue("isUSCitizen") === false
              ? "No"
              : ""
          }}</mat-label>
        </div>
      </div>
    </div>
    <mat-error *ngIf="formGroup.get('isUSCitizen')?.invalid && ((isPWABrand$ | async))" class="mat-form-field-appearance-outline mat-form-field-subscript-wrapper">
      {{ this.getFieldError('isUSCitizen') }}
    </mat-error>
  </div>
  <ng-container *ngIf="!isInAuthenticatedFlow">
    <div
      fxLayout="row"
      fxLayout.xs="column"
      fxLayoutAlign="space-between stretch"
      fxLayoutGap="10px"
      *ngIf="formGroup.get('isUSCitizen')?.value === false"
    >
      <div
        fxFlex="100"
        fxLayout="column"
        fxLayoutAlign="end start"
        fxLayoutGap="5px"
      >
        <mat-label-tooltip
          [showToolTip]="reviewState != reviewStates.ReadOnly"
          id="citizenship-label"
          >{{ !isInReadOnlyState ? "* " : ""
          }}<label for="citizenship"
            >What is your country of citizenship?</label
          >
        </mat-label-tooltip>
  
        <div *ngIf="reviewState != reviewStates.ReadOnly || (isPWABrand$ | async)" class="form-input">
          <mat-form-field appearance="outline" id="citizenship">
            <mat-select
              matInput
              placeholder="-Select-"
              required
              id="citizenship"
              formControlName="citizenship"
              data-dd-privacy="mask-user-input"
              [compareWith]="compareValueWithSelection"
              label="Country of citizenship"
              aria-label="Country of citizenship"
              >
              <mat-option
                *ngFor="let curCountry of internationalCountries"
                [value]="curCountry.countryId"
                >{{ curCountry.countryName }}
              </mat-option>
            </mat-select>
            <mat-error>{{ this.getFieldError("citizenship") }}</mat-error>
          </mat-form-field>
        </div>
  
        <ng-container
          class="read-only-label"
          *ngIf="reviewState === reviewStates.ReadOnly && !isInAuthenticatedFlow && !(isPWABrand$ | async)"
        >
          <mat-label class="read-only-label" data-dd-privacy="mask">{{
            getCountryOfCitizenshipDescription()
          }}</mat-label>
        </ng-container>
      </div>
    </div>
  </ng-container>
</form>
